const key = (userId: string) => `clarix_sidebar_last_project_${userId}`;

export function readLastOpenedProject(userId: string): string | null {
  try {
    return localStorage.getItem(key(userId));
  } catch {
    return null;
  }
}

export function writeLastOpenedProject(userId: string, projectId: string) {
  try {
    localStorage.setItem(key(userId), projectId);
  } catch {
    // storage unavailable — remembering is best-effort
  }
}

const pathKey = (userId: string) => `clarix_sidebar_last_projects_path_${userId}`;

/** Last page visited in the Projects panel (a project tab, All or Archived), so the rail returns there. */
export function readLastProjectsPath(userId: string): string | null {
  try {
    return localStorage.getItem(pathKey(userId));
  } catch {
    return null;
  }
}

export function writeLastProjectsPath(userId: string, path: string) {
  try {
    localStorage.setItem(pathKey(userId), path);
  } catch {
    // storage unavailable — remembering is best-effort
  }
}
